import type { PrimitivePayload } from "../types";
import { MultipleChoice } from "../primitives/MultipleChoice";
import { DragSort } from "../primitives/DragSort";
import { Match } from "../primitives/Match";
import { OrderSequence } from "../primitives/OrderSequence";
import { ReadingComp } from "../primitives/ReadingComp";
import { PhotoUpload } from "../primitives/PhotoUpload";
import type {
  MultipleChoiceConfig,
  DragSortConfig,
  MatchConfig,
  OrderSequenceConfig,
  ReadingCompConfig,
  PhotoUploadConfig,
} from "../types";

interface Props {
  payload: PrimitivePayload;
  onScored: (result: { score: number; passed: boolean; raw: unknown }) => void;
}

/**
 * Discriminated dispatcher. Adding a new widget is one switch case + an
 * import + the primitive itself + the TS type in `types.ts`.
 */
export function PrimitiveRunner({ payload, onScored }: Props) {
  switch (payload.widget_kind) {
    case "multiple_choice":
      return (
        <MultipleChoice
          prompt={payload.prompt}
          config={payload.config as MultipleChoiceConfig}
          passingScore={payload.passing_score}
          onScored={onScored}
        />
      );
    case "drag_sort":
      return (
        <DragSort
          prompt={payload.prompt}
          config={payload.config as DragSortConfig}
          passingScore={payload.passing_score}
          onScored={onScored}
        />
      );
    case "match":
      return (
        <Match
          prompt={payload.prompt}
          config={payload.config as MatchConfig}
          passingScore={payload.passing_score}
          onScored={onScored}
        />
      );
    case "order_sequence":
      return (
        <OrderSequence
          prompt={payload.prompt}
          config={payload.config as OrderSequenceConfig}
          passingScore={payload.passing_score}
          onScored={onScored}
        />
      );
    case "reading_comp":
      return (
        <ReadingComp
          prompt={payload.prompt}
          config={payload.config as ReadingCompConfig}
          passingScore={payload.passing_score}
          onScored={onScored}
        />
      );
    case "photo_upload":
      return (
        <PhotoUpload
          prompt={payload.prompt}
          config={payload.config as PhotoUploadConfig}
          passingScore={payload.passing_score}
          onScored={onScored}
        />
      );
    default: {
      const exhaustive: never = payload.widget_kind;
      return (
        <div>
          Widget no soportado: <code>{String(exhaustive)}</code>
        </div>
      );
    }
  }
}
